import { BOARD } from "@grundbesitz/shared";
import type { PublicGameState, TradeSide } from "@grundbesitz/shared";
import { assetGroupOf, jailCardLabel } from "../../../lib/assets";
import { formatMoney } from "../../../lib/format";

/** Read-only list of what one side of an offer contains. */
export function SideView({ game, side }: { game: PublicGameState; side: TradeSide }) {
  const empty = side.cash === 0 && side.fields.length === 0 && side.jailCards.length === 0;
  if (empty) return <p className="text-sm text-ink-2">Nichts</p>;
  return (
    <ul className="space-y-1 text-sm">
      {side.fields.map((f) => {
        const group = assetGroupOf(f);
        const mortgaged = game.properties[f]?.mortgaged;
        return (
          <li key={f} className="flex flex-wrap items-center gap-x-2">
            <span
              aria-hidden="true"
              className="size-3 shrink-0 rounded-[3px] border border-black/25"
              style={{ background: group?.color }}
            />
            <span className="font-semibold">{BOARD[f].name}</span>
            <span className="shrink-0 text-xs text-ink-2">{group?.name}</span>
            {mortgaged && <span className="shrink-0 text-xs font-semibold text-warn">belastet</span>}
          </li>
        );
      })}
      {side.cash > 0 && (
        <li className="tabular-nums font-semibold">{formatMoney(side.cash)}</li>
      )}
      {side.jailCards.map((c) => (
        <li key={c} className="font-semibold">
          {jailCardLabel(c)}
        </li>
      ))}
    </ul>
  );
}
